import { rem, rgba } from 'polished';
import styled from 'styled-components';

import { IStyledInputProps } from './FancyRadioButton.types';

export const StyledLabel = styled.label`
  display: inline-flex;
  padding: ${({ theme }) =>
    `${rem(theme.spacings.xs)} ${rem(theme.spacings.s)}`};
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${({ theme }) => rem(theme.spacings.s)};
  font-weight: 400;
  line-height: 1.4;
  background-color: ${({ theme }) => theme.colors.main};
  border: 1px solid ${({ theme }) => theme.colors.cross.silverFox};
  border-radius: ${({ theme }) => rem(theme.spacings.xs)};
  cursor: pointer;
`;

export const StyledInput = styled.input<IStyledInputProps>`
  position: absolute;
  width: 0;
  height: 0;
  appearance: none;
  opacity: 0;

  &:not(:checked):not(:disabled) + ${StyledLabel}:hover {
    color: ${({ theme }) => theme.colors.cross.deepBlu};
    border-color: ${({ theme }) => theme.colors.cross.silverFox};
    box-shadow: 0 0 0
      ${({ theme }) =>
        `${rem('2px')} ${rgba(theme.colors.cross.silverFox, 0.2)}`};
  }

  &:checked + ${StyledLabel} {
    cursor: default;
  }

  &:disabled + ${StyledLabel} {
    opacity: 0.3;
    cursor: not-allowed;
  }

  &:not(:disabled):checked + ${StyledLabel} {
    color: ${({ theme }) => theme.colors.cross.black};
    border-color: ${({ theme, user }) => user && theme.colors[user].main};
    box-shadow: 0 0 0
      ${({ theme, user }) =>
        user && `${rem('2px')} ${rgba(theme.colors[user].mainAlternate, 0.2)}`};
  }
`;
